import ODAS from '@/utils/api/odas';

const Review = {
  createOrUpdateReview: (resource, reviewContent, commentId) => {
    let params = {};

    params.review = reviewContent;
    params.comment_id = commentId;

    return ODAS.post('/api/reviews/' + resource.resource_type.toLowerCase() + '/' + resource.id, params);
  },

  getCurrentUserRatingTags: (resource) => {
    let endpoint = '/api/reviews/rating_tags/' + resource.resource_type.toLowerCase() + '/' + resource.id;
    return ODAS.get(endpoint);
  }
};

export default Review;
